import reportWebVitals from './reportWebVitals';

import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store';
require('./bootstrap');
require('intersection-observer');

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

if (document.getElementById('app')) {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        {/*<React.StrictMode>*/}
        <App />
        {/*</React.StrictMode>*/}
      </BrowserRouter>
    </Provider>,
    document.getElementById('app')
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
